import React, { useEffect, useState } from 'react';
import { getCalendarToken, regenerateCalendarToken } from '../api';
import { API_URL } from '../api';
import { useLang } from '../LangContext';

interface Props {
  token: string;
}

const IcsSection = ({ token }: Props) => {
  const { t } = useLang();
  const [calendarToken, setCalendarToken] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getCalendarToken(token).then(setCalendarToken).catch(() => {});
  }, [token]);

  const feedUrl = calendarToken ? `${API_URL}/api/calendar/${calendarToken}.ics` : null;

  const handleCopy = () => {
    if (!feedUrl) return;
    navigator.clipboard.writeText(feedUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleRegenerate = async () => {
    if (!window.confirm(t.calendarFeedRegenerateWarning)) return;
    const newToken = await regenerateCalendarToken(token);
    setCalendarToken(newToken);
  };

  return (
    <section className="profile-section">
      <h4 className="profile-section-title">{t.calendarFeedHeading}</h4>
      <p className="duration-options-hint">{t.calendarFeedDescription}</p>

      {feedUrl && (
        <div className="calendar-feed-block" style={{ marginTop: 'var(--spacing-sm)' }}>
          <input
            className="calendar-feed-url"
            readOnly
            value={feedUrl}
            onFocus={(e) => e.target.select()}
          />
          <div className="calendar-feed-actions">
            <button className="button button-sm button-outline" onClick={handleCopy}>
              {copied ? t.calendarFeedCopied : t.calendarFeedCopy}
            </button>
            <button className="button button-sm button-outline button-danger-outline" onClick={handleRegenerate}>
              {t.calendarFeedRegenerate}
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default IcsSection;
